module.exports = __webpack_public_path__ + "static/img/issue_matrix_2025.0f30e64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/stakeholder-identification/issue_matrix_2025.jpg
// module id = LlLJ
// module chunks = 98